<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem3">
				<div class="left">
					<a :href="item.href" :style="{ 'background-image' : 'url(' + item.img + ')' }" class="img"></a>
				</div>
				<div class="right">
					<div class="contentContainer">
						<div class="textHidden">
							<div class="text-header">
								{{item.header}}
							</div>
						</div>
						<div>
							<a :href="item.href" class="button waves-effect waves-light">{{item.button}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: false,
				margin: 30
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.slider-photo2 {
	@include m_up{
		margin-bottom: 76px;
		}
	b{
		font-weight: 900;
	}
	.owl-carousel {
		position: relative;
		padding-bottom: 70px;
    @include m_up{
      padding-bottom: 0;
    };
		.owl-stage-outer{
			padding: 0 1px;
		}
		.item {
			.containerItem3{
				display: flex;
				flex-direction: column;
				@include m___up{
					flex-direction: row;
				}
				& > *{
					width: 100%;
				}
				.left{
					border-radius: 8px;
					position: relative;
					overflow: hidden;
					height: 188px;
					.img{
						display: block;
						margin: 2px;
						position: absolute;
						top: 0;
						bottom: 0;
						left: 0;
						right: 0;
						margin: 0 auto;
						width: 100%;
						height: 100%;
						background-position: center;
						background-size: cover;
					}
				}
				.right{
					padding-left: 0px;
					padding-top: 30px;
					@include m___up{
						padding-left: 30px;
						padding-top: 0px;
						&:after{
							top: calc(50% - 9px);
							left: -12px;
						}
					}
					.contentContainer{
						padding: 30px;
						border: 1px solid #e2edf3;
						margin: 2px;
						border-radius: 8px;
						position: relative;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						height: 188px;
						.textHidden{
              max-height: rem(66);
							overflow: hidden;
							margin-bottom: 10px;

							.text-header{
								font-weight: 900;
								font-size: rem(15);
								line-height: rem(22);
							}
						}
						&:after{
							content: "";
							position: absolute;
							top: -12px;
							left: calc(50% - 6px);
							width: 12px;
							height: 18px;
							background-image: url('../img/arrow.jpg');
							background-size: cover;
							transform: rotate(90deg);
							@include m___up{
								left: -10px;
								top: calc(50% - 9px);
								transform: rotate(0deg);
							}
						}
					}
				}
				.button{
					/*margin-top: 23px;*/
					margin-right: 30px;
				}
			}
		}
    .owl-nav{
      font-size: 0;
      display: flex;
      justify-content:space-between;
      width: 100px;
      position: absolute;
      right: 0;
      bottom: 20px;
      top: auto;
      z-index: 4;
      @include m_up{
        top: calc(50% - 21px);
        bottom: auto;
        width: 100%;
      };
      div{
        width: 42px;
        height: 42px;
        border-radius: 100%;
        @include single-transition();
        background-size: 25px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('../img/arr.svg');
        border: 1px solid black;
        background-color: #fff;
        &:hover{
          background-image: url('../img/arr2.svg');
			background-color: var(--bg-hover);
			border-color: var(--bg-hover);
        }
      }
      .owl-prev{
        transform: rotate(90deg);
        position: relative;
        left: 0;
		  bottom: 0px;
        @include m_up{
          left: -68px;
        };
      }
      .owl-next{
        transform: rotate(-90deg);
		  bottom: 0px;
        position: relative;
        right: 0;
        @include m_up{
          right: -68px;
        };
      }
    }
		.owl-stage-outer{
			z-index: 5;
		}
	}
}
</style>



// WEBPACK FOOTER //
// slider-photo2.vue?26633bc2